module.exports = __webpack_public_path__ + "img/val-employee.b7643cba.png";